export default __webpack_public_path__ + "static/email-templates-preview-signature-050058ce7fd784ba6835e040cbaff404.mp4";